import { useRef, useState } from 'react';
import type { Language } from '../content/content';
import { content } from '../content/content';
import { SurveyButton } from './SurveyButton';

type AudioPlayerProps = {
  language: Language;
};

export function AudioPlayer({ language }: AudioPlayerProps) {
  const copy = content[language];
  const audioRef = useRef<HTMLAudioElement | null>(null);
  const [finished, setFinished] = useState(false);

  return (
    <section className="audioExperience" aria-labelledby="audio-title">
      <div className="audioArtwork" aria-hidden="true">
        <img src="/brand/logo.png" alt="" />
      </div>
      <div className="audioContent">
        <p className="eyebrow">{copy.audioDurationLabel}</p>
        <h2 id="audio-title">{copy.audioTitle}</h2>
        <p>{copy.audioSupport}</p>
        <audio
          ref={audioRef}
          className="audioPlayer"
          controls
          preload="metadata"
          src={copy.audioPath}
          onPlay={() => setFinished(false)}
          onEnded={() => setFinished(true)}
        >
          {language === 'es'
            ? 'Tu navegador no puede reproducir este audio.'
            : 'Your browser cannot play this audio.'}
        </audio>
        <a className="secondaryButton" href={copy.audioPath} download>
          {copy.audioDownloadLabel}
        </a>
      </div>

      {finished ? (
        <aside className="completionPanel" aria-live="polite">
          <div>
            <h2>{copy.finalCardTitle}</h2>
            <p>{copy.audioFinished}</p>
            <p className="privacyNote">{copy.privacyNote}</p>
          </div>
          <SurveyButton language={language} />
          <small>{copy.surveySmallText}</small>
        </aside>
      ) : null}
    </section>
  );
}
